<div class="card">
  <div class="card-body pl-0 pr-0 pb-0">
    <div class="pl-0 pr-0 pb-0 actions-container">
      <div class="row p-3">
        <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12">
          <div class="input-group">
            <input class="form-control border-right-0"
                   #filter
                   type="text"
                   placeholder="BUSCAR"
                   [(ngModel)]="searchString">
            <span class="input-group-append bg-white border-left-0">
            <span class="input-group-text bg-transparent">
              <i class="bi bi-search"></i>
            </span>
        </span>
          </div>
        </div>

      </div>
    </div>
    <div class="table-responsive">
      <table class="table table acierto-table-color">
        <thead>
        <tr class="text-white d-flex default-font-size">
          <th class="col-5">NOMBRE DEL ROL</th>
          <th class="col-4">DESCRIPCIÓN</th>
          <th class="col-1 text-center">EDITAR</th>
          <th class="col-2 text-center">ACTIVAR / DESACTIVAR</th>
        </tr>
        </thead>
        <tbody class="default-table-body-color default-font-size">
        <tr class="d-flex" *ngFor="let role of roles |
          filter: searchString">
          <td class="col-5">{{ role.nombre }}</td>
          <td class="col-4">{{ role.descripcion }}</td>
          <td class="col-1 text-center">
            <i class="bi bi-pencil-square action-icon"
               *ngxPermissionsOnly="['editarRol']"
               [routerLink]="['/modulo-seguridad/', 'seguridad', 'creacion-rol']"
               (click)="changeMenuModule('creacion-rol'); editRole(role)"></i>
          </td>
          <td class="col-2 text-center">
            <input
              type="checkbox"
              id="chk2"
              [checked]="role.activo"
              (change)="role.activo = $event.target.checked; changeRolStatus(role)">
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
